import { createContext, useState, useEffect } from "react";
import { orderSummaryModal } from "../services/useHome";

const DataContext = createContext({});

export const DataProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    JSON.parse(sessionStorage.getItem("customer_details"))?.customer_id ? true : false
  );
  const [dailyLimitExceeded, setDailyLimitExceeded] = useState(false);
  const [cartItems, setCartItems] = useState(() => {
    const savedCart = sessionStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });
  const [voucherData, setVoucherData] = useState(() => {
    const voucherData = sessionStorage.getItem("orderSummaryVoucher");
    return voucherData ? JSON.parse(voucherData) : [];
  });
  const [orderSummary, setOrderSummary] = useState({
    ...orderSummaryModal,
    order_items: [...cartItems],
    is_voucher_applied: voucherData.length > 0 ? 1 : 0,
    voucher: voucherData,
  });
  const [orderSummaryResponse, setOrderSummaryResponse] = useState({});

  useEffect(() => {
    let selectedLocation = JSON.parse(sessionStorage.getItem("selectedLocation"));
    console.log(selectedLocation);
    if (selectedLocation) {
      setOrderSummary((prevState) => ({
        ...prevState,
        distributor_id: sessionStorage.getItem("dist_id"),
        address: {
          ...prevState.address,
          shipping: {
            ...orderSummary.address.shipping,
            ...selectedLocation,
          },
          billing: {
            ...orderSummary.address.billing,
            ...selectedLocation,
          },
        },
      }));
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem("cart", JSON.stringify(cartItems));
  }, [cartItems]);

  useEffect(() => {
    console.log(orderSummary);
  }, [orderSummary]);

  return (
    <DataContext.Provider
      value={{
        cartItems,
        setCartItems,
        isLoggedIn,
        setIsLoggedIn,
        dailyLimitExceeded,
        setDailyLimitExceeded,
        orderSummary,
        setOrderSummary,
        orderSummaryResponse,
        setOrderSummaryResponse,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export default DataContext;
